import { Controller } from "@hotwired/stimulus"

// Toggle visibility of the Présentiel / Visio blocks in the admin
// consultation form depending on the selected format value.
//
// Targets:
//   - select   → the <select name="consultation[format]">
//   - online   → block to show when value == "online"
//   - inPerson → block to show when value == "in_person"
//
export default class extends Controller {
  static targets = ["select", "online", "inPerson"]

  connect() {
    this.refresh()
  }

  refresh() {
    const value = this.selectTarget.value
    if (this.hasOnlineTarget) {
      this.onlineTarget.style.display = value === "online" ? "" : "none"
    }
    if (this.hasInPersonTarget) {
      this.inPersonTarget.style.display = value === "in_person" ? "" : "none"
    }
  }
}
